import { render, staticRenderFns } from "./AddBoardToGroup.vue?vue&type=template&id=b96f9eee&scoped=true&"
import script from "./AddBoardToGroup.vue?vue&type=script&lang=ts&"
export * from "./AddBoardToGroup.vue?vue&type=script&lang=ts&"
import style0 from "./AddBoardToGroup.vue?vue&type=style&index=0&id=b96f9eee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96f9eee",
  null
  
)

export default component.exports